import React, { useState } from "react";

export default function useOnChangeHandler<
  E extends HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
>(
  initialValue: string
): [
  string,
  React.ChangeEventHandler<E>,
  React.Dispatch<React.SetStateAction<string>>
] {
  const [v, setValue] = useState(initialValue);
  const onChange: React.ChangeEventHandler<E> = (e) => {
    const { value } = e.target;
    setValue(value);
  };
  return [v, onChange, setValue];
}
